import axios from "axios";
import _ from "lodash";
import store from "../store";

const moment = require("moment-timezone");
import { countryColorList } from "../lib/countryList";

// Get accessToken for user
let getAccessToken = () => {
    let publicAccessToken = store.getState().globalReducer.publicAccessToken;

    if (publicAccessToken) return publicAccessToken;

    let accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = window.location.origin + "/signin";
    }
    return accessToken;
};

let getUserId = () => {
    return localStorage.getItem("userId");
};

let getCompanyId = () => {
    // let companyDeets = localStorage.getItem("company");
    // if (!companyDeets) return;
    // let company = JSON.parse(companyDeets);
    // return company && company.company_id;
    let company = store.getState().globalReducer.company;
    return company && company.company_id;
};

let getLiteCompanyId = () => {
    let company = store.getState().globalReducer.company;
    return company && company.company_lite_company_id;
};

let getUserType = () => {
    let company = JSON.parse(localStorage.getItem("company"));
    return company.user_type;
};

//ChartName -> default Api Map
let chartUrlMap = {
    OverallShareOfVoice: "volOfConvSubtopicsCount",
    ShareOfVoiceNews: "volOfConvSubtopicsCount",
    EstReach: "estimatedReach",
};

let accTokCookie = (cname) => {
    let name_cookie = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name_cookie) == 0) {
            return c.substring(name_cookie.length, c.length);
        }
    }
    return "";
};

let delete_cookie = function (name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

/**
 * parse parameters to send to VolOfConv API
 * @returns {URLSearchParams} params for the url
 */
let getReqParams = (data, emptyTopics = true, shrofvoice) => {
    let params = new URLSearchParams();

    if (data.topicAccount === "topic" && !data.public_data) {
        if ((!emptyTopics && data.emptyTopics) || !data.emptyTopics) params.append("topic_data", JSON.stringify(data.topics_data));
    } else if (!data.public_data) {
        params.append("social_accounts", "all");
    }

    if (["Key Opinion Leaders", "Scanner"].includes(data.name) && !data.public_data) params.append("post_type", "0");

    data.languages && !data.public_data && params.append("language", data.languages);
    data.countries && !data.public_data && params.append("location", data.countries);
    data.platforms && !data.public_data && params.append("platform", data.platforms);

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.duration === "custom") {
        //params.append('start_date', moment(data.start_date).tz(tz).format('YYYY-MM-DDTHH:mm:00'))
        //params.append('end_date', moment(data.end_date).tz(tz).format('YYYY-MM-DDTHH:mm:00'))
        params.append("start_date", moment(data.start_date).format("YYYY-MM-DDTHH:mm:00"));
        params.append("end_date", moment(data.end_date).format("YYYY-MM-DDTHH:mm:59"));
    } else if (data.duration === "24HRS") {
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59"));
        params.append("start_date", moment(new Date()).tz(tz).subtract(1, "days").format("YYYY-MM-DDTHH:mm:00"));
    } else {
        params.append("duration", data.duration);
    }

    if (data.aggs_interval) {
        params.append("aggs-interval", data.aggs_interval);
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.delete("end_date");
        params.append("end_date", moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59"));
    }

    if (data.entityType !== "all" && data.entityType !== "") {
        formatEntityType(params, data.entityType, data.entitySubType);
    }

    // Functions to calculate aggregate interval
    // if (data.duration === '24HRS' || data.duration === '1') {
    // 	params.append('aggs-interval', 'hour');
    // } else if (data.duration == '7') {
    // 	params.append('aggs-interval', 'day');
    // } else if (data.duration == '30') {
    // 	params.append('aggs-interval', 'week');
    // } else {
    // 	let diff = moment(data.end_date).diff(moment(data.start_date), 'days');
    // 	if (diff <= 1) {
    // 		params.append('aggs-interval', 'hour');
    // 	} else if (diff > 1 && diff <= 29) {
    // 		params.append('aggs-interval', 'day');
    // 	} else if (diff > 29 && diff <= 90) {
    // 		params.append('aggs-interval', 'week');
    // 	} else if (diff > 90 && diff <= 500) {
    // 		params.append('aggs-interval', 'month');
    // 	} else {
    // 		params.append('aggs-interval', 'year');
    // 	}
    // }

    if (data.sorting_val) {
        params.append("clustering_sort_order", "desc");
        params.append("clustering_sort_by", data.sorting_val);
        if (data.sorting_val === "impact") params.append("post_type", 0);
    }

    if (data.publications && !data.public_data) {
        if (data.publications === "all_tagged_pubs")
            params.append(
                "publication",
                JSON.parse(localStorage.getItem("filterOptions"))
                    .publications.map((elem) => elem.name)
                    .toString(),
            );
        else if (data.publications === "all_untagged_pubs") params.append("fields_not_exist", "publications");
        else if (data.publications === "not_listed_pubs") {
            let configured_publications = JSON.parse(localStorage.getItem("filterOptions")).publications.map((elem) => elem.name);
            params.append("publications_not_in", configured_publications.toString());
        } else params.append("publication", data.publications);
    }

    params.append("groupSize", 50);

    if (data.post_address_country) {
        params.append("post_address_country", data.post_address_country);
    }

    if (data.custom_query && data.custom_query !== "") params.append("custom_query", data.custom_query);
    let current_id = window.location.hash.split("/")[2];
    let all_filters = JSON.parse(localStorage.getItem("filters"));
    let view_name = all_filters.filter((elem) => elem.id === parseInt(current_id) && elem.view_type === "system");
    if (view_name.length && (view_name[0].name.toLowerCase() === "social" || view_name[0].name.toLowerCase() === "social+news") && !data.public_data) {
        params.append("exclude_account_type", "1,2,3");
    }

    if (data.public_data && shrofvoice) {
        let topics = [];
        let filterOptions = JSON.parse(localStorage.getItem("filterOptions"));
        let topics_available = [];
        let i;
        for (i = 0; i < filterOptions.topics.length; i++) {
            if (!topics_available.includes(filterOptions.topics[i].topic_id)) {
                topics_available.push(filterOptions.topics[i].topic_id);
            }
        }
        for (i = 0; i < topics_available.length; i++) {
            let children = filterOptions.topics.filter((elem) => elem.topic_id === topics_available[i]);
            let subtopicIds = children.map((elem) => elem.subtopic_id);
            let subtopicNames = [];
            subtopicIds.forEach((element) => {
                subtopicNames.push({ id: element, name: filterOptions.topics.find((elem) => elem.subtopic_id === element).subtopic_name });
            });
            topics.push({
                topic_id: topics_available[i],
                name: filterOptions.topics.find((elem) => elem.topic_id === topics_available[i]).topic_name,
                subtopicIds,
                subtopicNames,
            });
        }
        params.append("topic_data", JSON.stringify(topics));
    }

    if (data.public_data) params.append("public_data", 1);
    addExtraParams(data, params);

    return params;
};

const addExtraParams = (data, params) => {
    if (data.extras) {
        data.extras.forEach((param) => {
            if (param.apply_exclusion) params.append("apply_exclusion", param.apply_exclusion);
            if (param.key === "Gender") {
                let genderVal = param.key === "unknown" ? "unknown,na,unisex" : param.key;
                params.append("gender", genderVal);
            }
            if (param.key === "region") params.append("region", param.value);
            if (param.key === "Sentiment") params.append("sentiment", param.value);
            if (param.key === "User") params.append("username", param.value);
            if (param.key === "post_media_type") params.append("post_media_type", param.key);
            if (param.key === "contentSafety") params.append("contentSafety", params.value);
        });
    }
};

export const formatfbInsightsData = (dt, startDate, endDate, type, key, durationGap) => {
    // console.log(type);
    let totalPageView = { data: [] };
    let totalPageLikes = { data: [] };
    let videos = { data: [] };
    let home = { data: [] };
    let about = { data: [] };
    let reviews = { data: [] };
    let posts = { data: [] };
    let services = { data: [] };
    let computers = { data: [] };
    let mobiles = { data: [] };
    let pageLikes = { data: [] };
    let pageEngagement = { data: [] };
    let pageReach = { data: [] };
    let paidLikeType = { data: [] };
    let netLikeType = { data: [] };
    let unpaidLikeType = { data: [] };
    let unlikeLikeType = { data: [] };
    let totalLikeType = { data: [] };
    let adsLikeType = { data: [] };
    let mobileLikeType = { data: [] };
    let newsFeedLikeType = { data: [] };
    let pageSuggestionsLikeType = { data: [] };
    let restoredLikesFromReactivatedAccounts = { data: [] };
    let searchLikeType = { data: [] };
    let yourPageLikeType = { data: [] };
    let commentEngagement = { data: [] };
    let likeEngagement = { data: [] };
    let shareEngagement = { data: [] };
    let otherEngagement = { data: [] };
    let totalEngagement = { data: [] };
    let totalAverageEngagement = { nodata: true };
    let postEngagementRate = { nodata: true };
    let fbTotalEngagementCount = { nodata: true };
    let totalPostLikes = { nodata: true };
    let paidReach = { data: [] };
    let unpaidReach = { data: [] };
    let totalReach = { data: [] };
    let likeLikeType = { data: [] };
    let avgLikeLikeType = { data: [] };
    let angerLikeType = { data: [] };
    let avgAngerLikeType = { data: [] };
    let hahaLikeType = { data: [] };
    let avgHahaLikeType = { data: [] };
    let loveLikeType = { data: [] };
    let avgLoveLikeType = { data: [] };
    let sorryLikeType = { data: [] };
    let avgSorryLikeType = { data: [] };
    let wowLikeType = { data: [] };
    let avgWowLikeType = { data: [] };
    let totalPageViewBySection = { data: [] };
    let viewByDevice = { data: [] };
    let audienceByAge = { data: {} };
    let audienceByGender = { data: {} };
    let audienceByCountries = { data: {} };
    let prevTotalReachCount = 0;
    let currTotalReachCount = 0;
    let prevTotalEngagementCount = 0;
    let currTotalEngagementCount = 0;
    let prevTotalFollowersCount = 0;
    let currTotalFollowersCount = 0;
    let recentPosts = [];
    let postTypes = [];
    let postsOvertime = [];
    startDate = moment(new Date(startDate)).utc();
    endDate = moment(new Date(endDate)).utc();
    let diff = endDate.utc().diff(startDate, "hours");

    if (diff > 24) {
        var daysDiff = endDate.diff(startDate, "days");
        var startOf = endDate.startOf("day").valueOf();
    }

    if (dt != undefined) {
        if (
            type === "fbTotalPostCommentsBlock" ||
            type === "fbTotalPostSharesBlock" ||
            type === "fbTotalPostReactionsBlock" ||
            type === "fbTotalPostsBlock" ||
            type === "fbTotalPageViewsBlock" ||
            type === "fbTotalEngagementBlock" ||
            type === "fbTotalPageReachBlock"
        ) {
            const { data: presentDurationData } = dt.find((r) => r.name === "presentDurationData");
            const { data: previousDurationData } = dt.find((r) => r.name === "previousDurationData");

            const getTotalReactionsValue = (period) => {
                return period?.aggregations?.reactions_datewise_breakdown?.buckets?.reduce(
                    (acc, data) =>
                        acc +
                        data.angry_count?.value +
                        data.haha_count?.value +
                        data.like_count?.value +
                        data.love_count?.value +
                        data.sad_count?.value +
                        data.thankful_count?.value +
                        data.wow_count?.value,
                    0,
                );
            };
            const getDataForGivenDurationAndAggs = (duration, aggsVal) => {
                return duration?.aggregations?.[aggsVal]?.buckets?.reduce((acc, data) => acc + data.data_stats?.sum, 0);
            };
            const getPageLevelData = (duration) => {
                return duration?.total?.reduce((acc, data) => acc + data.count, 0);
            };
            const obj = {
                presentDurationData: null,
                previousDurationData: null,
                nodata: false,
                avg_val: null,
                percentage_change: null,
                durationGap: +durationGap.toFixed(0),
            };

            obj.nodata = presentDurationData?.hits?.total == 0;
            Object.keys(obj).length === 0;
            if (presentDurationData?.hits?.total == 0 || Object.keys(presentDurationData).length === 0) obj.nodata = true;

            switch (type) {
                case "fbTotalPageViewsBlock":
                    obj.presentDurationData = getPageLevelData(presentDurationData);
                    obj.previousDurationData = getPageLevelData(previousDurationData);
                    obj.avg_val = +(obj.presentDurationData / obj.durationGap).toFixed(2);
                    break;

                case "fbTotalPageReachBlock":
                    obj.presentDurationData = getPageLevelData(presentDurationData);
                    obj.previousDurationData = getPageLevelData(previousDurationData);
                    obj.avg_val = +(obj.presentDurationData / obj.durationGap).toFixed(2);
                    break;

                case "fbTotalPostCommentsBlock":
                    obj.presentDurationData = getDataForGivenDurationAndAggs(presentDurationData, "comments_datewise_breakdown");
                    obj.previousDurationData = getDataForGivenDurationAndAggs(previousDurationData, "comments_datewise_breakdown");
                    obj.avg_val = +presentDurationData?.aggregations?.comments_datewise_breakdown?.buckets
                        ?.reduce((acc, data) => acc + data.data_stats?.avg, 0)
                        .toFixed(2);
                    break;

                case "fbTotalPostSharesBlock":
                    obj.presentDurationData = getDataForGivenDurationAndAggs(presentDurationData, "shares_datewise_breakdown");
                    obj.previousDurationData = getDataForGivenDurationAndAggs(previousDurationData, "shares_datewise_breakdown");

                    obj.avg_val = +presentDurationData?.aggregations?.shares_datewise_breakdown?.buckets
                        ?.reduce((acc, data) => acc + data.data_stats?.avg, 0)
                        .toFixed(2);
                    break;

                case "fbTotalPostsBlock":
                    obj.presentDurationData = presentDurationData?.hits?.total;
                    obj.previousDurationData = previousDurationData?.hits?.total;
                    obj.avg_val = +(obj.presentDurationData / obj.durationGap).toFixed(2);
                    break;

                case "fbTotalEngagementBlock": {
                    const aggsArr = ["comments_datewise_breakdown", "shares_datewise_breakdown", "reactions_datewise_breakdown"];
                    let presentSum = 0;
                    let prevSum = 0;

                    aggsArr.forEach((aggsVal) => {
                        if (aggsVal === "reactions_datewise_breakdown") {
                            presentSum += getTotalReactionsValue(presentDurationData);
                            prevSum += getTotalReactionsValue(previousDurationData);
                        } else {
                            presentSum += getDataForGivenDurationAndAggs(presentDurationData, aggsVal);
                            prevSum += getDataForGivenDurationAndAggs(previousDurationData, aggsVal);
                        }
                    });
                    obj.presentDurationData = presentSum;
                    obj.previousDurationData = prevSum;
                    obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(2);
                    break;
                }

                case "fbTotalPostReactionsBlock":
                    obj.presentDurationData = getTotalReactionsValue(presentDurationData);
                    obj.previousDurationData = getTotalReactionsValue(previousDurationData);
                    obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(2);
                    break;

                default:
                    break;
            }
            if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

            if (!obj.nodata) {
                if (obj.previousDurationData !== 0)
                    obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
            }
            return { [type]: obj };
        }

        if (type == "totalViews") {
            dt.total &&
                dt.total.forEach((k, v) => {
                    totalPageView.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
        }

        if (type === "fbPostOvertime") {
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            dt.forEach((k) => {
                postsOvertime.push([+moment(k.key).tz(tz).format("x"), k.doc_count]);
            });
        }

        if (type == "totalUniqueViews") {
            dt.total_unique &&
                dt.total_unique.forEach((k, v) => {
                    totalPageView.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
        }
        if (type == "totalLikes") {
            dt.total &&
                dt.total.forEach((k, v) => {
                    totalPageLikes.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            if (dt.total && dt.unlike) {
                dt.total.forEach((k, v) => {
                    netLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
        }
        if (type === "fb_page_follower_by_total" && key === "fbTotalFollowersCount") {
            let prevTotal = 0;
            let currTotal = 0;
            dt[0].data?.total?.forEach((k, v) => {
                prevTotal += k.count;
            });
            dt[1].data?.total?.forEach((k, v) => {
                currTotal += k.count;
            });
            prevTotalFollowersCount = prevTotal;
            currTotalFollowersCount = currTotal;
        }
        if (type == "totalUniqueLikes") {
            dt.paid_unique &&
                dt.paid_unique.forEach((k, v) => {
                    paidLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.unpaid_unique &&
                dt.unpaid_unique.forEach((k, v) => {
                    unpaidLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.total_unique &&
                dt.total_unique.forEach((k, v) => {
                    totalPageLikes.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            if (dt.unlike_unique) {
                dt.unlike_unique.forEach((k, v) => {
                    unlikeLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
            if (dt.total_unique && dt.unlike_unique) {
                dt.total_unique.forEach((k, v) => {
                    netLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
        }
        if (dt.paid != undefined) {
            dt.paid.forEach((k, v) => {
                paidLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (dt.unpaid != undefined) {
            dt.unpaid.forEach((k, v) => {
                unpaidLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.unlike != undefined) {
            dt.unlike.forEach((k, v) => {
                unlikeLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (type === "totalAverageEngagement") {
            // console.log(dt);
            // totalAverageEngagement = dt;

            let obj = {
                nodata: dt.hits.total === 0,
                likes_agg: [],
                comments_agg: [],
                shares_agg: [],
                total_agg: [],
                likes_avg: [],
                comments_avg: [],
                shares_avg: [],
                total_avg: [],
                avg_value: 0,
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
            };

            let tz = JSON.parse(localStorage.company).user_timezone_name;

            let total_agg = {};
            let total_avg = {};
            let total = 0;

            dt.aggregations.reactions_datewise_breakdown?.buckets.forEach((likes) => {
                let d = +moment(likes.key).tz(tz).format("x");
                let sum =
                    likes.like_count.value +
                    likes.love_count.value +
                    likes.sad_count.value +
                    likes.thankful_count.value +
                    likes.wow_count.value +
                    likes.angry_count.value +
                    likes.haha_count.value;

                let avg = likes.doc_count > 0 ? sum / likes.doc_count : 0;

                obj.likes_agg.push([d, sum || 0]);
                obj.likes_avg.push([d, avg || 0]);

                total_agg[d] = sum;
                total_avg[d] = avg;
                total += sum;
            });

            dt.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
                let d = +moment(comments.key).tz(tz).format("x");
                obj.comments_agg.push([d, comments.data_stats.sum || 0]);
                obj.comments_avg.push([d, comments.data_stats.avg || 0]);

                total_agg[d] += comments.data_stats.sum;
                total_avg[d] += comments.data_stats.avg;
                total += comments.data_stats.sum;
            });

            dt.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
                let d = +moment(shares.key).tz(tz).format("x");
                obj.shares_agg.push([d, shares.data_stats.sum || 0]);
                obj.shares_avg.push([d, shares.data_stats.avg || 0]);

                total_agg[d] += shares.data_stats.sum;
                total_avg[d] += shares.data_stats.avg;
                total += shares.data_stats.sum;
            });

            obj.total_agg = Object.entries(total_agg).map(([k, v]) => {
                obj.max = Math.max(obj.max, v);
                obj.min = Math.min(obj.min, v);
                return [+k, v || 0];
            });
            obj.total_avg = Object.entries(total_avg).map(([k, v]) => [+k, v || 0]);

            let totalLength = dt.hits.total || 1;

            obj.avg_value = +(total / totalLength).toFixed(2);

            totalAverageEngagement = obj;
        }

        if (type === "pageFollowersData") {
            const obj = {
                nodata: false,
                total_agg: [],
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
            };
            let total = 0;

            const tz = JSON.parse(localStorage.company).user_timezone_name;
            // console.log("dt", dt.follower_info?.buckets);
            dt.follower_info?.buckets?.forEach((k, v) => {
                const date = +moment(k.date).tz(tz).format("x");
                obj.total_agg.push([date, k.followersCount || +dt.follower_info?.total || 0]);
                total += k.followersCount;
                obj.max = Math.max(obj.max, k.followersCount);
                obj.min = Math.min(obj.min, k.followersCount);
            });

            obj.nodata = dt.follower_info?.total === 0;
            // let totalLength = dt.follower_info?.total || 1;

            obj.avg_value = +(total / dt.follower_info?.buckets?.length || 1).toFixed(2);

            return { pageFollowersData: obj };
        }

        if (type === "postEngagementRate") {
            // console.log("dataaaaa", dt);

            // dt.total &&
            //     dt.total.forEach((k, v) => {
            //         totalPageLikes.data.push([
            //             moment(k.key * 1000)
            //                 .set({ h: 0, m: 0, s: 0, ms: 0 })
            //                 .valueOf(),
            //             k.count,
            //         ]);
            //     });
            // if (dt.total && dt.unlike) {
            //     dt.total.forEach((k, v) => {
            //         netLikeType.data.push([
            //             moment(k.key * 1000)
            //                 .set({ h: 0, m: 0, s: 0, ms: 0 })
            //                 .valueOf(),
            //             k.count,
            //         ]);
            //     });
            // }

            const { data: followersData } = dt.find((obj) => obj.name === "followersData");
            const { data: engagementData } = dt.find((obj) => obj.name === "engagementData");

            const obj = {
                nodata: false,
                total_agg: [],
            };
            const tz = JSON.parse(localStorage.company).user_timezone_name;
            let total = 0;
            const total_agg = {};
            let totalRate = 0;

            engagementData?.aggregations?.reactions_datewise_breakdown?.buckets.forEach((likes) => {
                let d = +moment(likes.key).tz(tz).format("x");
                let sum =
                    likes.like_count.value +
                    likes.love_count.value +
                    likes.sad_count.value +
                    likes.thankful_count.value +
                    likes.wow_count.value +
                    likes.angry_count.value +
                    likes.haha_count.value;

                // obj.likes_agg.push([d, sum || 0]);
                // obj.likes_avg.push([d, avg || 0]);

                total_agg[d] = sum;
                total += sum;
            });

            engagementData?.aggregations?.comments_datewise_breakdown.buckets.forEach((comments) => {
                let d = +moment(comments.key).tz(tz).format("x");
                total_agg[d] += comments.data_stats.sum;
                total += comments.data_stats.sum;
            });

            engagementData?.aggregations?.shares_datewise_breakdown.buckets.forEach((shares) => {
                let d = +moment(shares.key).tz(tz).format("x");

                total_agg[d] += shares.data_stats.sum;
                total += shares.data_stats.sum;
            });

            const followersDataAggs = {};
            const totalAggsList = Object.values(total_agg);

            followersData?.follower_info?.buckets?.forEach((k, indx) => {
                // const date = +moment(k.key * 1000)
                //     .set({ h: 0, m: 0, s: 0, ms: 0 })
                //     .valueOf();
                // const date = +moment(k.key).tz(tz).format("x"); this was not matching with the engagement date

                const date = +moment(k.date).tz(tz).format("x");
                // console.log("total_agg[date]", total_agg, total_agg[date]);
                if (totalAggsList[indx] && k.followersCount > 0) {
                    followersDataAggs[date] = +(totalAggsList[indx] / k.followersCount || 0).toFixed(4);
                    // console.log("total_agg[date]", followersDataAggs[date], k.followersCount);
                    totalRate += followersDataAggs[date];
                } else {
                    followersDataAggs[date] = 0;
                }
            });

            Object.entries(followersDataAggs)?.map(([date, value]) => [+date, value]);
            obj.nodata = totalRate === 0;
            obj.total_agg = Object.entries(followersDataAggs)?.map(([date, value]) => [+date, value || 0]);
            postEngagementRate = obj;
        }

        if (type === "totalPostComments") {
            let obj = {
                nodata: dt.hits.total === 0,
                comments_agg: [],
                avg_value: 0,
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
            };

            let total = 0;
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            dt.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
                let d = +moment(comments.key).tz(tz).format("x");
                obj.comments_agg.push([d, comments.data_stats.sum || 0]);
                obj.max = Math.max(obj.max, comments.data_stats.sum);
                obj.min = Math.min(obj.min, comments.data_stats.sum);
                total += comments.data_stats.sum;
            });

            let totalLength = dt.hits.total || 1;

            obj.avg_value = +(total / totalLength).toFixed(2);

            return { totalPostComments: obj };
        }

        if (type === "totalPostShares") {
            let obj = {
                nodata: dt.hits.total === 0,
                shares_agg: [],
                avg_value: 0,
                max: Number.MIN_SAFE_INTEGER,
                min: Number.MAX_SAFE_INTEGER,
            };

            let total = 0;
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            dt.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
                let d = +moment(shares.key).tz(tz).format("x");
                obj.shares_agg.push([d, shares.data_stats.sum || 0]);
                obj.max = Math.max(obj.max, shares.data_stats.sum);
                obj.min = Math.min(obj.min, shares.data_stats.sum);
                total += shares.data_stats.sum;
            });

            let totalLength = dt.hits.total || 1;

            obj.avg_value = +(total / totalLength).toFixed(2);

            return { totalPostShares: obj };
        }

        if (dt.total != undefined && type != "totalEngagement") {
            dt.total.forEach((k, v) => {
                totalLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (dt.videos != undefined) {
            dt.videos.forEach((k, v) => {
                videos.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.about != undefined) {
            dt.about.forEach((k, v) => {
                about.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.home != undefined) {
            dt.home.forEach((k, v) => {
                home.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.reviews != undefined) {
            dt.reviews.forEach((k, v) => {
                reviews.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.posts != undefined) {
            dt.posts.forEach((k, v) => {
                posts.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.services != undefined) {
            dt.services.forEach((k, v) => {
                services.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.other_unique !== undefined) {
            dt.other_unique.forEach((k, v) => {
                computers.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.mobile_unique !== undefined) {
            dt.mobile_unique.forEach((k, v) => {
                mobiles.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (dt.ads != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    adsLikeType.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.ads.forEach((k, v) => {
                if (
                    adsLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    adsLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }
        if (dt.mobile != undefined) {
            dt.mobile.forEach((k, v) => {
                mobileLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.news_feed != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    newsFeedLikeType.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.news_feed.forEach((k, v) => {
                if (
                    newsFeedLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    newsFeedLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }
        if (dt.page_suggestions != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    pageSuggestionsLikeType.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.page_suggestions.forEach((k, v) => {
                if (
                    pageSuggestionsLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    pageSuggestionsLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }
        if (dt.restored_likes_from_reactivated_accounts != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    restoredLikesFromReactivatedAccounts.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.restored_likes_from_reactivated_accounts.forEach((k, v) => {
                if (
                    restoredLikesFromReactivatedAccounts.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    restoredLikesFromReactivatedAccounts.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }
        if (dt.search != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    searchLikeType.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.search.forEach((k, v) => {
                if (
                    searchLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    searchLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }
        if (dt.your_page != undefined) {
            if (diff > 24) {
                for (let i = daysDiff; i >= 1; i--) {
                    yourPageLikeType.data.push([startOf - i * 24 * 60 * 60 * 1000, 0]);
                }
            }
            dt.your_page.forEach((k, v) => {
                if (
                    yourPageLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )
                )
                    yourPageLikeType.data.find(
                        (elem) =>
                            elem[0] ==
                            moment(k.key * 1000)
                                .set({ h: 0, m: 0, s: 0, ms: 0 })
                                .valueOf(),
                    )[1] = k.count;
            });
        }

        if (dt.comment != undefined) {
            dt.comment.forEach((k, v) => {
                commentEngagement.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.like != undefined && type != "totalPostLikes") {
            dt.like.forEach((k, v) => {
                likeEngagement.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.link != undefined) {
            dt.link.forEach((k, v) => {
                shareEngagement.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.other != undefined) {
            dt.other.forEach((k, v) => {
                otherEngagement.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (type === "fbRecentPosts" && dt?.length > 0) {
            // dt = dt.filter((item) => item?._source?.post?.post_subtype !== "ads");
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            dt?.forEach((item) => {
                if (item) {
                    let image_url =
                        "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
                    let profile_pic =
                        "https://2020assets.s3.amazonaws.com/images/" +
                        item?._source?.post_author?.media[0].folder +
                        "/" +
                        item?._source?.post_author?.media[0].name;
                    let totalEngagement =
                        item?._source.post?.engagement_values?.like_count +
                        item?._source.post?.engagement_values?.comment_count +
                        item?._source.post?.engagement_values?.share_count +
                        item?._source.post?.engagement_values?.view_count;
                    recentPosts.push({
                        gender: item?._source?.post_author?.gender,
                        profile_pic: profile_pic,
                        username: item?._source?.handlers[0].value,
                        post_type: item?._source?.post?.media[0].type,
                        image_url: image_url,
                        content: item?._source?.post?.content,
                        title: item?._source?.post?.title,
                        post_url: item?._source?.post?.url,
                        created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                        hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                        engagement: item?._source?.post?.engagement_values,
                        totalEngagement: totalEngagement,
                        impact: item?._source.impact_value,
                    });
                }
            });
            // recentPosts.sort(function (a, b) {
            //     return parseFloat(b.totalEngagement) - parseFloat(a.totalEngagement);
            // });

            recentPosts = recentPosts.filter((post) => !post?.post_url?.includes("stories"));
            recentPosts = recentPosts.slice(0, 10);
        }

        if (type === "fbPostTypeDistribution") {
            let texts = 0,
                images = 0,
                videos = 0;
            dt?.forEach((item) => {
                if (item.key === "image") images = item.doc_count;
                if (item.key === "text") texts = item.doc_count;
                if (item.key === "video") videos = item.doc_count;
            });
            postTypes.push({ Text: texts, Image: images, Video: videos });
        }

        if (dt.total != undefined && type == "totalEngagement") {
            dt.total &&
                dt.total.forEach((k, v) => {
                    totalEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
        }
        if (type === "fbTotalEngagementCount") {
            let eng1 = dt.find((r) => r.name === "eng1");
            let eng2 = dt.find((r) => r.name === "eng2");

            let obj = {
                eng1: null,
                eng2: null,
                nodata: false,
                avg_reach: null,
                percentage_change: null,
                // durationGap: +data.durationGap.toFixed(0),
            };

            obj.nodata = eng1.data?.hits.total == 0;
            // comments_datewise_breakdown, shares_datewise_breakdown, reactions_datewise_breakdown;
            obj.eng1 =
                eng1.data?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
                eng1.data?.aggregations?.shares_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
                eng1.data?.aggregations?.reactions_datewise_breakdown?.buckets?.reduce((acc, val) => {
                    let sum =
                        val.like_count.value +
                        val.love_count.value +
                        val.sad_count.value +
                        val.thankful_count.value +
                        val.wow_count.value +
                        val.angry_count.value +
                        val.haha_count.value;
                    return acc + sum;
                }, 0);
            obj.eng2 =
                eng2.data?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
                eng2.data?.aggregations?.shares_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
                eng2.data?.aggregations?.reactions_datewise_breakdown?.buckets?.reduce((acc, val) => {
                    let sum =
                        val.like_count.value +
                        val.love_count.value +
                        val.sad_count.value +
                        val.thankful_count.value +
                        val.wow_count.value +
                        val.angry_count.value +
                        val.haha_count.value;
                    return acc + sum;
                }, 0);

            if ((obj.eng1 && !(obj.eng1 > 0)) || obj.eng1 === 0 || (obj.eng1 === 0 && obj.eng1 === 0)) obj.nodata = true;

            if (!obj.nodata) {
                obj.avg_reach = +(obj.eng1 / eng1.data?.hits.total).toFixed(2);
                if (obj.eng2 !== 0) obj.percentage_change = +(((obj.eng1 - obj.eng2) / obj.eng2) * 100).toFixed(2);
            }

            fbTotalEngagementCount = obj;
        }

        if (type == "totalUniqueEngagement") {
            dt.comment_unique &&
                dt.comment_unique.forEach((k, v) => {
                    commentEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.like_unique &&
                dt.like_unique.forEach((k, v) => {
                    likeEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.link_unique &&
                dt.link_unique.forEach((k, v) => {
                    shareEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.other_unique &&
                dt.other_unique.forEach((k, v) => {
                    otherEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            dt.total_unique &&
                dt.total_unique.forEach((k, v) => {
                    totalEngagement.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
        }

        if (dt.total != undefined && type == "totalReach") {
            dt.total.forEach((k, v) => {
                totalReach.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (type === "fb_page_reach_by_total" && key === "fbTotalReachCount") {
            let prevTotal = 0;
            let currTotal = 0;
            dt[0].data?.total?.forEach((k, v) => {
                prevTotal += k.count;
            });
            dt[1].data?.total?.forEach((k, v) => {
                currTotal += k.count;
            });
            prevTotalReachCount = prevTotal;
            currTotalReachCount = currTotal;
        }
        if (dt.paid != undefined && type == "totalReach") {
            dt.paid.forEach((k, v) => {
                paidReach.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.unpaid != undefined && type == "totalReach") {
            dt.unpaid.forEach((k, v) => {
                unpaidReach.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (type == "totalUniqueReach") {
            if (dt.paid_unique) {
                dt.paid_unique.forEach((k, v) => {
                    paidReach.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
            if (dt.unpaid_unique) {
                dt.unpaid_unique.forEach((k, v) => {
                    unpaidReach.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
            if (dt.total_unique) {
                dt.total_unique.forEach((k, v) => {
                    totalReach.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                });
            }
        }

        if (dt.anger != undefined) {
            dt.anger.forEach((k, v) => {
                totalReach.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }

        if (type === "totalAveragePostLikes" && dt?.postData && dt?.countData) {
            const { postData, countData } = dt;
            const { like, anger, haha, love, sorry, wow } = countData;
            like &&
                like.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgLikeLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
            anger &&
                anger.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgAngerLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
            haha &&
                haha.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgHahaLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
            love &&
                love.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgLoveLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
            sorry &&
                sorry.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgSorryLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
            wow &&
                wow.forEach((k, v) => {
                    postData.forEach((s, t) => {
                        const countDate = moment(k.key_as_string);
                        if (countDate.isSame(s.key_as_string)) {
                            const posts = s.doc_count;

                            const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                            avgWowLikeType.data.push([
                                moment(k.key * 1000)
                                    .set({ h: 0, m: 0, s: 0, ms: 0 })
                                    .valueOf(),
                                Number(avg.toFixed(1)),
                            ]);
                        }
                    });
                });
        }

        if (type == "totalPostLikes") {
            let obj = {
                nodata: dt.hits.total === 0,
                likes_agg: [],
                haha_agg: [],
                wow_agg: [],
                love_agg: [],
                angry_agg: [],
                sad_agg: [],
                // thankful_agg: [],
                total_reactions_agg: [],
                likes_avg: [],
                haha_avg: [],
                wow_avg: [],
                love_avg: [],
                angry_avg: [],
                sad_avg: [],
                // thankful_avg: [],
                total_reactions_avg: [],
                avg_value: 0,
                min: Number.MAX_SAFE_INTEGER,
                max: Number.MIN_SAFE_INTEGER,
            };

            let tz = JSON.parse(localStorage.company).user_timezone_name;
            let total = 0;

            dt.aggregations.reactions_datewise_breakdown?.buckets.forEach((likes) => {
                let d = +moment(likes.key).tz(tz).format("x");
                let sum =
                    likes.like_count.value +
                    likes.love_count.value +
                    likes.sad_count.value +
                    // likes.thankful_count.value +
                    likes.wow_count.value +
                    likes.angry_count.value +
                    likes.haha_count.value;

                let avg = likes.doc_count > 0 ? likes.doc_count : 1;

                obj.likes_agg.push([d, likes.like_count.value || 0]);
                obj.likes_avg.push([d, likes.like_count.value / avg || 0]);
                obj.love_agg.push([d, likes.love_count.value || 0]);
                obj.love_avg.push([d, likes.love_count.value / avg || 0]);
                obj.sad_agg.push([d, likes.sad_count.value || 0]);
                obj.sad_avg.push([d, likes.sad_count.value / avg || 0]);
                obj.wow_agg.push([d, likes.wow_count.value || 0]);
                obj.wow_avg.push([d, likes.wow_count.value / avg || 0]);
                obj.angry_agg.push([d, likes.angry_count.value || 0]);
                obj.angry_avg.push([d, likes.angry_count.value / avg || 0]);
                obj.haha_agg.push([d, likes.haha_count.value || 0]);
                obj.haha_avg.push([d, likes.haha_count.value / avg || 0]);

                obj.max = Math.max(
                    obj.max,
                    likes.like_count.value,
                    likes.love_count.value,
                    likes.sad_count.value,
                    likes.wow_count.value,
                    likes.angry_count.value,
                    likes.haha_count.value,
                );
                obj.min = Math.min(
                    obj.min,
                    likes.like_count.value,
                    likes.love_count.value,
                    likes.sad_count.value,
                    likes.wow_count.value,
                    likes.angry_count.value,
                    likes.haha_count.value,
                );

                obj.total_reactions_agg.push([d, sum || 0]);
                obj.total_reactions_avg.push([d, sum / avg || 0]);
                total += sum;
            });

            let totalPosts = dt.hits.total || 1;

            obj.avg_value = +(total / totalPosts).toFixed(2);

            totalPostLikes = obj;
        }

        if (dt.haha != undefined) {
            dt.haha.forEach((k, v) => {
                hahaLikeType.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.love != undefined) {
            dt.love.forEach((k, v) => {
                try {
                    loveLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                } catch (err) {
                    console.log(err);
                }
            });
        }
        if (dt.sorry != undefined) {
            dt.sorry.forEach((k, v) => {
                try {
                    sorryLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                } catch (err) {
                    console.log(err);
                }
            });
        }
        if (dt.wow != undefined) {
            dt.wow.forEach((k, v) => {
                try {
                    wowLikeType.data.push([
                        moment(k.key * 1000)
                            .set({ h: 0, m: 0, s: 0, ms: 0 })
                            .valueOf(),
                        k.count,
                    ]);
                } catch (err) {
                    console.log(err);
                }
            });
        }

        if (type === "fbTotalAudienceByAge" || type === "fbTotalAudienceByGender") {
            let maleVal = 0;
            let femaleVal = 0;

            dt &&
                Object.entries(dt).map(([key, value]) => {
                    let gender = key.split(".")[0];
                    let age = key.split("_")[0].split(".")[1];

                    let ageVal = 0;

                    value.map((k, v) => {
                        ageVal += k.count;
                        if (gender === "f") femaleVal += k.count;

                        if (gender === "m") maleVal += k.count;

                        audienceByAge.data[age] = ageVal;
                    });
                });

            audienceByGender.data.Male = maleVal;
            audienceByGender.data.Female = femaleVal;
        }

        if (type == "fbTotalAudienceByCountry") {
            dt &&
                Object.entries(dt).map(([key, value]) => {
                    let country = key.split("_")[0];

                    let countryVal = 0;
                    value.map((k, v) => (countryVal += k.count));
                    audienceByCountries.data[country] = countryVal;
                });
        }
    }
    let x = {
        totalPageView: totalPageView,
        totalPageLikes: totalPageLikes,
        videos: videos,
        about: about,
        home: home,
        posts: posts,
        reviews: reviews,
        services: services,
        computers: computers,
        mobiles: mobiles,
        paidLikeType: paidLikeType,
        unpaidLikeType: unpaidLikeType,
        unlikeLikeType: unlikeLikeType,
        totalLikeType: totalLikeType,
        netLikeType: netLikeType,
        adsLikeType: adsLikeType,
        mobileLikeType: mobileLikeType,
        newsFeedLikeType: newsFeedLikeType,
        pageSuggestionsLikeType: pageSuggestionsLikeType,
        restoredLikesFromReactivatedAccounts: restoredLikesFromReactivatedAccounts,
        searchLikeType: searchLikeType,
        yourPageLikeType: yourPageLikeType,
        commentEngagement: commentEngagement,
        likeEngagement: likeEngagement,
        shareEngagement: shareEngagement,
        otherEngagement: otherEngagement,
        totalEngagement: totalEngagement,
        totalReach: totalReach,
        paidReach: paidReach,
        unpaidReach: unpaidReach,
        likeLikeType: likeLikeType,
        loveLikeType: loveLikeType,
        angerLikeType: angerLikeType,
        wowLikeType: wowLikeType,
        hahaLikeType: hahaLikeType,
        sorryLikeType: sorryLikeType,
        totalPageViewBySection: totalPageViewBySection,
        viewByDevice: viewByDevice,
        audienceByCountries,
        audienceByAge,
        audienceByGender,
        totalReachCount: { prev: prevTotalReachCount, curr: currTotalReachCount },
        totalEngagementCount: { prev: prevTotalEngagementCount, curr: currTotalEngagementCount },
        totalFollowersCount: { prev: prevTotalFollowersCount, curr: currTotalFollowersCount },
        recentPosts,
        postTypes,
        totalAverageEngagement,
        postEngagementRate,
        totalPostLikes,
        avgLikeLikeType,
        avgAngerLikeType,
        avgLoveLikeType,
        avgHahaLikeType,
        avgSorryLikeType,
        avgWowLikeType,
        postsOvertime,
        fbTotalEngagementCount,
    };
    return x;
};

export const formatfbImpressionsData = (data, startDate, endDate, type, key) => {
    let paidImpressionData = {
        data: [],
    };
    let organicImpressionData = {
        data: [],
    };
    let totalImpressionData = {
        data: [],
    };

    data.forEach((dt) => {
        if (dt.paid) {
            dt.paid.forEach((k, v) => {
                paidImpressionData.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.organic) {
            dt.organic.forEach((k, v) => {
                organicImpressionData.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
        if (dt.total) {
            dt.total.forEach((k, v) => {
                totalImpressionData.data.push([
                    moment(k.key * 1000)
                        .set({ h: 0, m: 0, s: 0, ms: 0 })
                        .valueOf(),
                    k.count,
                ]);
            });
        }
    });

    let res = {
        totalImpressionData,
        organicImpressionData,
        paidImpressionData,
    };

    return res;
};
export const formatNewsPubAgg = (dt) => {
    let topics = [];
    dt.dataSet.forEach((tpc) => {
        let topic = {
            name: tpc.input.name,
            id: tpc.input.topic_id,
            subtopicIds: tpc.input.subtopicIds,
            subtopicNames: tpc.input.subtopicNames,
            values: [],
        };

        // store in dict
        if (topic.name.toLowerCase() !== "tags") {
            let pubsDict = {};
            tpc.data.forEach((sbtpc) => {
                sbtpc.data.aggregations.volume_of_conversation.buckets.forEach((pub) => {
                    pubsDict[pub.key] = pubsDict[pub.key] ? pubsDict[pub.key] + pub.doc_count : pub.doc_count;
                });
            }, this);
            // convert dict to Array
            let pubsArr = [];
            for (let pub in pubsDict) {
                pubsArr.push({ name: pub, val: pubsDict[pub] });
            }
            topic.values = pubsArr;
            topics.push(topic);
        } else {
            let pubsDict = {};
            tpc.uniqueData.aggregations.volume_of_conversation.buckets.forEach((pub) => {
                pubsDict[pub.key] = pubsDict[pub.key] ? pubsDict[pub.key] + pub.doc_count : pub.doc_count;
            });
            let pubsArr = [];
            for (let pub in pubsDict) {
                pubsArr.push({ name: pub, val: pubsDict[pub] });
            }
            topic.values = pubsArr;
            topics.push(topic);
        }
    }, this);

    // filter empty
    topics = topics.filter((topic) => topic.values.length !== 0);

    // store in dict
    let allValues = {};
    topics.forEach((topic) => {
        topic.values.forEach((pub) => {
            allValues[pub.name] = allValues[pub.name] ? allValues[pub.name] + pub.val : pub.val;
        });
    });

    let all = { values: [] };
    if (
        dt.overAllUniqueData &&
        dt.overAllUniqueData.aggregations &&
        dt.overAllUniqueData.aggregations.volume_of_conversation &&
        dt.overAllUniqueData.aggregations.volume_of_conversation.buckets
    ) {
        let data = dt.overAllUniqueData.aggregations.volume_of_conversation.buckets;
        for (let pub in dt.overAllUniqueData.aggregations.volume_of_conversation.buckets) {
            all.values.push({ name: data[pub].key, val: data[pub].doc_count });
        }
    }
    // // convert to array
    // for (let pub in allValues) {
    // 	all.values.push({ name: pub, val: allValues[pub] })
    // }
    return { all, topics };
};
export const formatAggMentions = (dt) => {
    let ret = [];
    dt.dataSet.forEach((tpc) => {
        let topic = {
            name: tpc.input.name,
            id: tpc.input.topic_id,
            value: 0,
            uniqueValue: tpc.uniqueData.hits.total,
            subtopics: [],
        };
        tpc.data.forEach((subtpc) => {
            let subtopic = {
                id: subtpc.sub_topic_id,
                name: tpc.input.subtopicNames.find((subtpcMap) => subtpcMap.id === subtpc.sub_topic_id).name,
                value: subtpc.data.hits.total,
            };
            topic.subtopics.push(subtopic);
        }, this);
        // sum subtopic values to get topic values
        topic.subtopics.forEach((subtpc) => (topic.value += subtpc.value), this);
        ret.push(topic);
    }, this);
    ret.push({ total_unique_data: dt.overAllUniqueData.hits.total });
    return ret;
};

let fetchVOCSubtpcsCnt = (data, url, API_AGG_PUB_MENTIONS) => {
    let params = getReqParams(data, false, data.public_data ? true : false);
    let res = axios({
        method: "post",
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: params,
    })
        .then((res) => res.data)
        .then((dt) => {
            let formattedData = {};
            formattedData.newsPubData = formatNewsPubAgg(dt);
            formattedData.aggMentionsData = formatAggMentions(dt);
            return formattedData;
        });
    return {
        type: API_AGG_PUB_MENTIONS,
        payload: res,
    };
};

let formatTimeSeriesMentions = (data) => {
    let xsSet = new Set();
    data.forEach((tpc) => {
        tpc.data.forEach((subtpc) => {
            subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                xsSet.add(bucket.key);
            });
        });
    }, this);
    let xs = [];
    xsSet.forEach((elem) => xs.push(elem));
    xs.sort();
    let topics = [];
    data.forEach((tpc) => {
        let topic = { id: tpc.input.topic_id, name: tpc.input.name, values: new Array(xs.length).fill(0) };
        tpc.data.forEach((subtpc) => {
            subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                let timeIndex = xs.indexOf(bucket.key);
                topic.values[timeIndex] += bucket.doc_count;
            });
        });
        topics.push(topic);
    }, this);
    return {
        name: "all",
        xs,
        res: topics,
    };
};

let formatTimeSeriesMentionsSubtopics = (data) => {
    let xsSet = new Set();
    data.forEach((tpc) => {
        tpc.data.forEach((subtpc) => {
            subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                xsSet.add(bucket.key);
            });
        });
    }, this);
    let xs = [];
    xsSet.forEach((elem) => xs.push(elem));
    xs.sort();
    let subtopics = [];
    data[0].data.forEach((subtpc) => {
        let subtopic = {
            name: data[0].input.subtopicIdNameMap[subtpc.sub_topic_id],
            id: subtpc.sub_topic_id,
            values: new Array(xs.length).fill(0),
        };
        subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
            let timeIndex = xs.indexOf(bucket.key);
            subtopic.values[timeIndex] = bucket.doc_count;
        }, this);
        subtopics.push(subtopic);
    });

    return {
        name: data[0].input.name,
        xs,
        res: subtopics,
    };
};

let formatTimeSeriesPubData = (data) => {
    let res = {
        name: data.length === 1 ? data[0].input.name : "all",
    };
    let xsSet = new Set();
    data.forEach((tpc) => {
        tpc.data.forEach((sbtpc) => {
            sbtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                xsSet.add(bucket.key);
            }, this);
        });
    }, this);
    let xs = [];
    xsSet.forEach((elem) => xs.push(elem));
    xs.sort();
    let pubsDict = {};
    data.forEach((tpc) => {
        tpc.data.forEach((subtpc) => {
            subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                let timestampIndex = xs.indexOf(bucket.key);
                bucket.publication_breakup.buckets.forEach((pubBucket) => {
                    if (!pubsDict[pubBucket.key]) pubsDict[pubBucket.key] = new Array(xs.length).fill(0);
                    pubsDict[pubBucket.key][timestampIndex] += pubBucket.doc_count;
                });
            });
        }, this);
    }, this);

    // dict to array
    let pubsArr = [];
    for (let pub in pubsDict) {
        if (pubsDict[pub].reduce((sum, val) => sum + val, 0) > 0) pubsArr.push({ name: pub, values: pubsDict[pub] });
    }
    res.xs = xs;
    res.res = pubsArr;
    return res;
};

const formatEntityType = (params, et, est) => {
    let paramest = [];
    let entityType = et.split(",");
    let entitySubType = est.split(",");

    let boolStrings = [];

    if (entityType.includes("person")) {
        let personBoolean = "post.entity_type:person ";
        let subParams = [];
        if (entitySubType.includes("male")) subParams.push("male");
        if (entitySubType.includes("female")) subParams.push("female");
        if (entitySubType.includes("unknown")) subParams.push("unknown");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            personBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${personBoolean})`);
    }

    if (entityType.includes("non-person")) {
        let nonPerBoolean = "post.entity_type:non-person ";
        let subParams = [];
        if (entitySubType.includes("brand")) subParams.push("brand");
        if (entitySubType.includes("news")) subParams.push("news");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            nonPerBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${nonPerBoolean})`);
    }

    if (entityType.includes("unknown")) {
        boolStrings.push(`(post.entity_type:unknown)`);
    }

    params.append("entity_boolean", boolStrings.join(" OR "));
};

const getMomentsData = (buckets, top_moments) => {
    let momentsData = [];
    _.forEach(buckets, (b) => {
        let currentObj = { id: b.key, value: b.doc_count, name: top_moments.find((elem) => elem.id === b.key).name };
        momentsData.push(currentObj);
    });
    return momentsData;
};
const getMomentsOvertimeData = (buckets, top_moments) => {
    var x = [];
    _.forEach(buckets, (bucket) => {
        _.forEach(bucket.data_over_time.buckets, (b) => {
            if (!x.includes(b.key)) {
                x.push(b.key);
            }
        });
    });
    x.sort();
    let responseObj = {};
    responseObj.xs = x;

    _.forEach(buckets, (bucket) => {
        let keyName = top_moments.find((elem) => elem.id === bucket.key).name;
        responseObj[keyName] = [];
        for (let i = 0; i < x.length; i++) {
            let elem = bucket.data_over_time.buckets.find((temp) => temp.key === x[i]);
            if (elem) {
                responseObj[keyName].push(elem.doc_count);
            } else {
                responseObj[keyName].push(0);
            }
        }
    });
    return responseObj;
};

const get_cookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

const getAppliedDates = (filters) => {
    let start_date, end_date;
    if (filters.duration !== "custom" && filters.duration !== "24HRS") {
        start_date = moment().subtract(parseInt(filters.duration), "days").format("YYYY-MM-DD");
        end_date = moment(new Date()).format("YYYY-MM-DD");
    } else if (filters.duration === "custom") {
        start_date = moment(filters.startDateTime).format("YYYY-MM-DD");
        end_date = moment(filters.endDateTime).format("YYYY-MM-DD");
    } else {
        start_date = moment(moment().unix() * 1000 - 24 * 60 * 60 * 1000).format("YYYY-MM-DD");
        end_date = moment(moment().unix() * 1000).format("YYYY-MM-DD");
    }

    return { start_date, end_date };
};

const getDateParamsTrends = (duration, start, end) => {
    const user_timezone_name = JSON.parse(localStorage.getItem("company")).user_timezone_name;
    let today = moment();
    let start_date = moment();
    let end_date;

    switch (duration) {
        case "1":
            start_date = moment(start_date).subtract(24, "h");
            break;
        case "30":
            start_date = moment(start_date).subtract(30 - 1, "d");
            break;
        case "custom":
            start_date = moment(start);
            today = moment(end);
            break;
        case "7":
        default:
            start_date = moment(start_date).subtract(duration - 1, "d");
            break;
    }

    if (duration === "7" || duration === "30" || duration === "1") {
        start_date = moment(start_date).format("YYYY-MM-DDT00:00:00");
        end_date = moment(today).format("YYYY-MM-DDT23:59:59");
    } else {
        start_date = moment(start_date).format("YYYY-MM-DDTHH:mm:00");
        end_date = moment(today).format("YYYY-MM-DDTHH:mm:00");
    }
    return { start_date, end_date };
};

const truncate = (str, max = 80) => {
    const ellipsis = str?.length > max ? "..." : "";
    return str?.slice(0, max) + ellipsis || "";
};

export const formatTwitterInsightsData = (dt, startDate, endDate, type, chartName) => {
    // dt = resp.data

    let pageEngagementRateOverTime = { data: [] };
    let followersOverTime = { data: [] };
    let engagementOverTime = { data: [] };
    let impressionOverTime = { data: [], avg_value: 0 };
    let impressionNonOrganicOverTime = { data: [], avg_value: 0 };
    let impressionTotal = { data: [], avg_value: 0 };
    let retweetOverTime = { data: [], avg_value: 0 };
    let likesOverTime = { data: [], avg_value: 0 };
    let avgEngagementsOverTime = { data: [] };
    let quotesOverTime = { data: [], avg_value: 0 };
    let tweet_overtime = { data: [] };
    let repliesOverTime = { data: [] };
    let followersLostAndGain = { data: [] };
    let postTypes = { data: [] };
    let recentPosts = { data: [] };
    let engagementPerTweetType = { data: {} };
    let impressionPerTweetType = { data: {} };
    let videoViewsOverTime = { data: [] };
    let totalValuesData = {};

    startDate = moment(new Date(startDate)).utc();
    endDate = moment(new Date(endDate)).utc();
    let diff = endDate.utc().diff(startDate, "hours");
    let daysDiff;
    let startOf;

    if (diff > 24) {
        daysDiff = endDate.diff(startDate, "days");
        startOf = endDate.startOf("day").valueOf();
    }

    if (dt !== undefined) {
        if (chartName) {
            let obj = {
                presentDurationData: null,
                previousDurationData: null,
                nodata: false,
                avg_val: null,
                percentage_change: null,
                // durationGap: +data.durationGap.toFixed(0),
            };

            let { data: presentDurationData } = dt.find((obj) => obj.name === "presentDurationData");
            let { data: previousDurationData } = dt.find((obj) => obj.name === "previousDurationData");

            // Math.round bcz avg enagaements is floating val
            obj.presentDurationData = Math.round(presentDurationData?.data?.[chartName.split("-")[0]]?.reduce((sum, curr) => sum + curr.total, 0));
            obj.previousDurationData = Math.round(previousDurationData?.data?.[chartName.split("-")[0]]?.reduce((acc, val) => acc + val?.total, 0));

            const totalPosts = presentDurationData?.data?.recent_posts_count?.count;
            if (obj.presentDurationData) obj.avg_val = Math.floor(obj.presentDurationData / totalPosts);
            if (chartName === "follower_growth_overtime-block" || chartName === "tweet_overtime-block") obj.avg_val = "NA";

            if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

            if (!obj.nodata) {
                if (obj.previousDurationData !== 0)
                    obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
            }
            return obj;
        }
        if (type === "page_engagement_rate") {
            const respData = {};
            const followersData = {};
            dt.data.page_engagement_overtime.forEach((value) => {
                respData[parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x"))] = value.total;
            });

            dt.data.follower_growth_overtime.forEach((value) => {
                const date = parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x"));
                if (respData[date] && value.total > 0) {
                    followersData[date] = +(respData[date] / value.total)?.toFixed(4);
                } else {
                    followersData[date] = 0;
                }
            });
            Object.entries(followersData)?.map(([date, value]) => pageEngagementRateOverTime?.data?.push([+date, value]));
        } else if (type === "follower_growth_overtime" && dt.data.follower_growth_overtime) {
            dt.data.follower_growth_overtime.forEach((value) => {
                followersOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
            });
        } else if (type === "follower_growth_overtime-gain" && dt.data.follower_growth_overtime) {
            dt.data.follower_growth_overtime.length > 1 &&
                dt.data.follower_growth_overtime.forEach((value, index) => {
                    if (index === 0)
                        followersLostAndGain.data.push({
                            x: parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")),
                            y: 0,
                            colorIndex: value.total,
                        });
                    else
                        followersLostAndGain.data.push({
                            x: parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")),
                            y: value.total - dt.data.follower_growth_overtime[index - 1].total,
                            colorIndex: value.total,
                        });
                });
        } else if (type === "video_views_overtime" && dt.data.video_views_overtime) {
            dt.data.video_views_overtime.forEach((value) => {
                videoViewsOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
            });
        } else if (type === "recent_posts" && dt.data.recent_posts) {
            // Recent posts
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            dt.data.recent_posts.forEach((value) => {
                let text = "";
                let postType = "";
                let header = "";
                let address = "";

                if (value.type === "replied_to") {
                    address = value.content
                        .split(" ")
                        .filter((word) => word[0] === "@")
                        .join(" ");
                    header = `Replied to`;
                    postType = "reply";
                    text = value.content
                        .split(" ")
                        .filter((word) => word[0] !== "@")
                        .join(" ");
                } else if (value.type === "quoted") {
                    address = value.content.split(" ")[value.content.split(" ").length - 1];
                    header = `Quoted`;
                    postType = "quote";
                    text = value.content
                        .split(" ")
                        .filter((word) => word !== value.content.split(" ")[value.content.split(" ").length - 1])
                        .join(" ");
                } else if (value.type === "retweeted") {
                    address = value.content
                        .split(" ")
                        .filter((word) => word[0] === "@")
                        .join(" ");
                    header = `Retweeted`;
                    postType = "retweet";
                    text = value.content
                        .split(" ")
                        .filter((word) => word[0] !== "@" && word !== "RT")
                        .join(" ");
                } else if (value.type === "tweet") {
                    text = value.content;
                    postType = "tweet";
                }

                recentPosts.data.push({
                    author: value.author_name,
                    user_id: value.page_name,
                    date: moment(value.published_date).format("DD MMM YYYY"),
                    hover_date: moment(value.published_date).format("LLLL z"),
                    post_url: value.post_url,
                    publishedDate: value.published_date,
                    postType: postType,
                    content: truncate(text),
                    address,
                    header: header,
                    media_type: value.media_type,
                    media_url: value.media_url,
                    post_id: value.post_id,
                    likes: value.like_count,
                    retweets: value.retweet_count,
                    replies: value.reply_count,
                    quotes: value.quote_count,
                    impressions: value.impression_count,
                    engagements: value.engagement_count,
                });
            });

            // recentPosts.data = recentPosts.data.slice(0, 10);
        } else if (type === "tweet_type_distribution_overall" && dt.data.tweet_type_distribution_overall) {
            let tweets = 0,
                retweets = 0,
                replies = 0,
                quotes = 0;
            dt.data.tweet_type_distribution_overall.forEach((value) => {
                if (value.type === "replied_to") replies = value.total;
                else if (value.type === "quoted") quotes = value.total;
                else if (value.type === "retweeted") retweets = value.total;
                else if (value.type === "tweet") tweets = value.total;
            });
            postTypes.data.push({ Tweets: tweets, Retweets: retweets, Quotes: quotes, Replies: replies });
        } else if (type === "page_engagement_overtime" && dt.data.page_engagement_overtime) {
            dt.data.page_engagement_overtime.forEach((value) => {
                engagementOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
            });
        } else if (type === "avg_engagement_per_tweet_type") {
            dt.data.avg_engagement_per_tweet_type &&
                Object.entries(dt.data.avg_engagement_per_tweet_type).map(([key, value]) => {
                    let title = "";
                    if (key === "photo") title = "Photo";
                    else if (key === "text") title = "Text";
                    else if (key === "video") title = "Video";
                    else if (key === "animated_gif") title = "GIF";
                    if (title !== "") engagementPerTweetType.data[title] = value.total;
                });
        } else if (type === "impression_per_tweet_type") {
            dt.data.impression_per_tweet_type &&
                Object.entries(dt.data.impression_per_tweet_type).map(([key, value]) => {
                    let title = "";
                    if (key === "photo") title = "Photo";
                    else if (key === "text") title = "Text";
                    else if (key === "video") title = "Video";
                    else if (key === "animated_gif") title = "GIF";
                    if (title !== "") impressionPerTweetType.data[title] = value.total;
                });
        } else if (type === "page_impression_overtime" && dt.data.page_impression_overtime) {
            // console.log("helllo", dt.data);
            let nonOrganicTotal = 0;
            dt.data.page_promoted_impression_overtime.forEach((value) => {
                impressionNonOrganicOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                // impressionOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                nonOrganicTotal += value.total;
            });
            let nonOrganicTotalLength = dt.data?.recent_posts_count?.count || 1;
            impressionNonOrganicOverTime.avg_value = +(total / nonOrganicTotalLength).toFixed(2);

            let total = 0;
            dt.data.page_impression_overtime.forEach((value) => {
                impressionOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });
            let totalLength = dt.data?.recent_posts_count?.count || 1;
            impressionOverTime.avg_value = +(total / totalLength).toFixed(2);

            dt.data.page_impression_overtime.forEach((value) => {
                impressionTotal.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });

            impressionTotal.data.forEach((ele) => {
                impressionNonOrganicOverTime.data.forEach((nextEle) => {
                    if (ele[0] == nextEle[0]) {
                        ele[1] = ele[1] + nextEle[1];
                    }
                });
            });

            impressionTotal.data.forEach((ele) => {
                impressionTotal.avg_value += ele[1];
            });
            impressionTotal.avg_value = (impressionTotal.avg_value / totalLength).toFixed(2);
        } else if (type === "page_retweet_overtime" && dt.data.page_retweet_overtime) {
            let total = 0;
            dt.data.page_retweet_overtime.forEach((value) => {
                retweetOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });
            let totalLength = dt.data?.recent_posts_count?.count || 1;
            retweetOverTime.avg_value = +(total / totalLength).toFixed(2);
        } else if (type === "page_like_overtime" && dt.data.page_like_overtime) {
            let total = 0;
            dt.data.page_like_overtime.forEach((value) => {
                likesOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });
            let totalLength = dt.data?.recent_posts_count?.count || 1;
            likesOverTime.avg_value = +(total / totalLength).toFixed(2);
        } else if (type === "page_avg_engagement_overtime" && dt.data.page_avg_engagement_overtime) {
            dt.data.page_avg_engagement_overtime.forEach((value) => {
                avgEngagementsOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), +value.total.toFixed(2)]);
            });
        } else if (type === "page_quote_overtime" && dt.data.page_quote_overtime) {
            let total = 0;
            dt.data.page_quote_overtime.forEach((value) => {
                quotesOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });
            let totalLength = dt.data?.recent_posts_count?.count || 1;
            quotesOverTime.avg_value = +(total / totalLength).toFixed(2);
        } else if (type === "page_reply_overtime" && dt.data.page_reply_overtime) {
            let total = 0;
            dt.data.page_reply_overtime.forEach((value) => {
                repliesOverTime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
                total += value.total;
            });
            let totalLength = dt.data?.recent_posts_count?.count || 1;
            repliesOverTime.avg_value = +(total / totalLength).toFixed(2);
        } else if (type === "basic_metric") {
            const previousData = dt[0].data.data.basic_metric;
            const currentData = dt[1].data.data.basic_metric;
            previousData && (totalValuesData.previous = JSON.parse(JSON.stringify(previousData)));
            currentData && (totalValuesData.current = JSON.parse(JSON.stringify(currentData)));
        } else if (type === "averageLikesOverTime" && dt?.postData && dt?.countData) {
            const { postData, countData } = dt;

            countData.data.page_like_overtime.forEach((k, v) => {
                postData.data.tweet_overtime.forEach((s, t) => {
                    const countDate = moment(k.data_at.split(" ")[0]);

                    if (countDate.isSame(s.data_at.split(" ")[0])) {
                        const posts = s.total;

                        const avg = isFinite(k.total / posts) ? k.total / posts : 0;

                        likesOverTime.data.push([parseInt(moment(k.data_at.split(" ")[0]).startOf("day").format("x")), Number(avg.toFixed(1))]);
                    }
                });
            });
        } else if (type === "tweet_overtime" && dt?.data?.tweet_overtime) {
            dt.data.tweet_overtime.forEach((value) => {
                tweet_overtime.data.push([parseInt(moment(value.data_at.split(" ")[0]).startOf("day").format("x")), value.total]);
            });
        }
    }

    let formattedData;

    switch (type) {
        case "page_engagement_rate":
            formattedData = pageEngagementRateOverTime;
            break;
        case "follower_growth_overtime":
            formattedData = followersOverTime;
            break;
        case "follower_growth_overtime-gain":
            formattedData = followersLostAndGain;
            break;
        case "recent_posts":
            formattedData = recentPosts;
            break;
        case "basic_metric":
            formattedData = totalValuesData;
            break;
        case "page_engagement_overtime":
            formattedData = engagementOverTime;
            break;
        case "page_impression_overtime":
            formattedData = { impressionOverTime, impressionNonOrganicOverTime, impressionTotal };
            break;
        case "page_retweet_overtime":
            formattedData = retweetOverTime;
            break;
        case "page_like_overtime":
            formattedData = likesOverTime;
            break;
        case "averageLikesOverTime":
            formattedData = likesOverTime;
            break;
        case "page_avg_engagement_overtime":
            formattedData = avgEngagementsOverTime;
            break;
        case "page_quote_overtime":
            formattedData = quotesOverTime;
            break;
        case "impression_per_tweet_type":
            formattedData = impressionPerTweetType;
            break;
        case "avg_engagement_per_tweet_type":
            formattedData = engagementPerTweetType;
            break;
        case "video_views_overtime":
            formattedData = videoViewsOverTime;
            break;
        case "page_reply_overtime":
            formattedData = repliesOverTime;
            break;
        case "tweet_type_distribution_overall":
            formattedData = postTypes;
            break;
        case "tweet_overtime":
            formattedData = tweet_overtime;
            break;
    }

    return formattedData;
};
//
export const formatInstagramInsightsData = (dt, startDate, endDate, name, isAverage) => {
    if (name === "audience_metrics_by_age") {
        let obj = dt.data;
        if (Object.keys(obj).length === 0) {
            return { nodata: true };
        }
        let malesLabel = ["m.13-17", "m.18-24", "m.25-34", "m.35-44", "m.45-54", "m.55-64", "m.65+"];
        let femalesLabel = ["f.13-17", "f.18-24", "f.25-34", "f.35-44", "f.45-54", "f.55-64", "f.65+"];
        let othersLabel = ["u.13-17", "u.18-24", "u.25-34", "u.35-44", "u.45-54", "u.55-64", "u.65+"];
        let hashMap = obj;
        let males = [];
        let females = [];
        let others = [];
        malesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                males.push(count);
            } else males.push(count);
        });
        femalesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                females.push(count);
            } else females.push(count);
        });
        othersLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                others.push(count);
            } else others.push(count);
        });
        let malesCount = males.reduce((x, y) => x + y, 0);
        let femalesCount = females.reduce((x, y) => x + y, 0);
        let otherCount = others.reduce((x, y) => x + y, 0);
        let totalCount = malesCount + femalesCount + otherCount;
        let pieChartData = [
            { name: "13-17", y: males[0] + females[0] + others[0] },
            { name: "18-24", y: males[1] + females[1] + others[1] },
            { name: "25-34", y: males[2] + females[2] + others[2] },
            { name: "35-44", y: males[3] + females[3] + others[3] },
            { name: "45-54", y: males[4] + females[4] + others[4] },
            { name: "55-64", y: males[5] + females[5] + others[5] },
            { name: "65+", y: males[6] + females[6] + others[6] },
        ];
        let barChartData = [
            { name: "13-17", data: [{ name: "13-17", y: males[0] + females[0] + others[0], total: totalCount }] },
            { name: "18-24", data: [{ name: "18-24", y: males[1] + females[1] + others[1], total: totalCount }] },
            { name: "25-34", data: [{ name: "25-34", y: males[2] + females[2] + others[2], total: totalCount }] },
            { name: "35-44", data: [{ name: "35-44", y: males[3] + females[3] + others[3], total: totalCount }] },
            { name: "45-54", data: [{ name: "45-54", y: males[4] + females[4] + others[4], total: totalCount }] },
            { name: "55-64", data: [{ name: "55-64", y: males[5] + females[5] + others[5], total: totalCount }] },
            { name: "65+", data: [{ name: "65+", y: males[6] + females[6] + others[6], total: totalCount }] },
        ];
        barChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return -1;
            }
            if (a.data[0].y < b.data[0].y) {
                return 1;
            } else return 0;
        });
        let labels = barChartData.map((ele) => ele.name);

        return { [name]: { barChartData: barChartData, pieChartData: pieChartData, labels: labels } };
    }
    if (name === "audience_metrics_by_gender") {
        let obj = dt.data;
        if (Object.keys(obj).length === 0) {
            return { nodata: true };
        }
        let labels = ["13-17", "18-24", "25-34", "35-44", "45-54", "55-64", "65+"];
        let malesLabel = ["m.13-17", "m.18-24", "m.25-34", "m.35-44", "m.45-54", "m.55-64", "m.65+"];
        let femalesLabel = ["f.13-17", "f.18-24", "f.25-34", "f.35-44", "f.45-54", "f.55-64", "f.65+"];
        let othersLabel = ["u.13-17", "u.18-24", "u.25-34", "u.35-44", "u.45-54", "u.55-64", "u.65+"];
        let hashMap = obj;
        let males = [];
        let females = [];
        let others = [];

        malesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                males.push(count);
            } else males.push(count);
        });
        femalesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                females.push(count);
            } else females.push(count);
        });
        othersLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                others.push(count);
            } else others.push(count);
        });
        let malesCount = males.reduce((x, y) => x + y, 0);
        let femalesCount = females.reduce((x, y) => x + y, 0);
        let othersCount = others.reduce((x, y) => x + y, 0);
        let totalVal = malesCount + femalesCount + othersCount;
        let pieChartData = [
            { name: "Male", y: malesCount, color: "#6CB4EE" },
            { name: "Female", y: femalesCount, color: "#FFAEBC" },
            { name: "Others", y: othersCount, color: "#A0E7E5" },
        ];
        let barChartData = [
            { name: "Male", count: malesCount, data: [{ name: "Male", y: malesCount, color: "#6CB4EE", total: totalVal }], color: "#6CB4EE" },
            { name: "Female", count: femalesCount, data: [{ name: "Female", y: femalesCount, color: "#FFAEBC", total: totalVal }], color: "#FFAEBC" },
            { name: "Others", count: othersCount, data: [{ name: "Others", y: othersCount, color: "#A0E7E5", total: totalVal }], color: "#A0E7E5" },
        ];
        let sortedbarChartData = barChartData.sort((a, b) => b.count - a.count);
        return { [name]: { barChartData: sortedbarChartData, pieChartData: pieChartData, total: totalVal } };
    }
    if (name === "audience_metrics_by_country") {
        let obj = dt.data;
        if (Object.keys(obj).length === 0) {
            return { nodata: true };
        }
        let barChartData = [];
        let pieChartData = [];
        let LocationWithData = [];
        let countryData = dt.data || {};
        const masterLocationList = countryColorList;
        let LocationKeys = [];
        let hashMap = [];
        for (const key in countryData) {
            let count = 0;
            countryData[key].forEach((ele) => {
                count += ele.count;
            });
            hashMap.push({ name: key, count: count });
            LocationKeys.push(key);
        }

        let locationHashMap = {};
        LocationKeys.forEach((short_name) => {
            let country = masterLocationList.find((ele) => ele.code.toLowerCase() == short_name);
            if (country) {
                locationHashMap[short_name] = country.country;
            }
        });
        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else 1;
        });
        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);
        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                obj["name"] = locationHashMap[ele.name];
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = locationHashMap[ele.name];
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                pieChartData.push({ name: locationHashMap[ele.name], y: ele.count });
                LocationWithData.push(locationHashMap[ele.name]);
            }
        });
        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                pieChartData.push({ name: "Others", y: count });
                barChartData.push(obj);
                LocationWithData.push("Others");
            }
        }
        return {
            [name]: {
                barChartData: barChartData,
                pieChartData: pieChartData,
                LocationWithData: LocationWithData,
                downLoadData: sortedHashMap,
                allLocation: locationHashMap,
            },
        };
    }
    if (name === "audience_metrics_by_city") {
        let barChartData = [];
        let pieChartData = [];
        let obj = dt.data;
        if (Object.keys(obj).length === 0) {
            return { nodata: true };
        }
        let cityLevelData = obj;
        let hashMap = [];
        let cityLocationWithData = [];
        for (const key in cityLevelData) {
            let count = 0;
            cityLevelData[key].forEach((ele) => {
                count += ele.count;
            });
            hashMap.push({ name: key, count: count });
        }
        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else 1;
        });
        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);
        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                obj["name"] = ele.name;
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = ele.name;
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                cityLocationWithData.push(ele.name);
                pieChartData.push({ name: ele.name, y: ele.count });
            }
        });
        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                cityLocationWithData.push("Others");
                pieChartData.push({ name: "Others", y: count });
            }
        }
        return { [name]: { barChartData: barChartData, pieChartData: pieChartData, cityLocationWithData: cityLocationWithData, downLoadData: sortedHashMap } };
    }
    if (name === "insta_story_by_taps") {
        let chartData = dt.data;
        let forwardDataLength = Object.keys(chartData?.insta_story_by_taps_forward).length;
        if (forwardDataLength === 0) {
            return {};
        }
        let forwardData = chartData?.insta_story_by_taps_forward?.total;
        let backwardData = chartData?.insta_story_by_taps_back?.total;
        let forwardLineChartData = forwardData.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        let backwardLineChartData = backwardData.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        return { [name]: { forward_taps: forwardLineChartData, backward_taps: backwardLineChartData } };
    }
    if (name === "insta_story") {
        let chartData = dt.data;
        let viewDataLength = Object.keys(chartData.insta_story_by_impression).length;
        if (viewDataLength === 0) {
            return {};
        }
        let viewData = chartData.insta_story_by_impression.total;
        let exitsData = chartData.insta_story_by_exits.total;
        let viewsLineChartData = viewData.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        let exitsLineChartData = exitsData.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        return { [name]: { views_data: viewsLineChartData, exits_data: exitsLineChartData } };
    }
    if (name === "IgRecentPosts" || name === "IgRecentStories") {
        dt = dt.filter((item) => item?._source?.post?.post_subtype !== "ads");
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let recentPosts = [];
        dt?.forEach((item) => {
            let image_url = "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
            let profile_pic =
                "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post_author?.media[0].folder + "/" + item?._source?.post_author?.media[0].name;
            let totalEngagement =
                item?._source.post?.engagement_values?.like_count +
                item?._source.post?.engagement_values?.comment_count +
                item?._source.post?.engagement_values?.share_count +
                item?._source.post?.engagement_values?.view_count;
            if (item) {
                recentPosts.push({
                    gender: item?._source?.post_author?.gender,
                    profile_pic: profile_pic,
                    username: item?._source?.handlers[0].value,
                    post_type: item?._source?.post?.media[0].type,
                    image_url: image_url,
                    content: item?._source?.post?.content,
                    title: item?._source?.post?.title,
                    post_url: item?._source?.post?.url,
                    created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                    hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                    engagement: item?._source?.post?.engagement_values,
                    totalEngagement: totalEngagement,
                });
            }
        });

        if (name !== "IgRecentStories") recentPosts = recentPosts.filter((post) => !post?.post_url?.includes("stories"));
        recentPosts = recentPosts.slice(0, 10);
        // recentPosts.sort(function (a, b) {
        //     return parseFloat(b.totalEngagement) - parseFloat(a.totalEngagement);
        // });

        if (name === "IgRecentStories") return { IgRecentStories: recentPosts };
        else return { IgRecentPosts: recentPosts };
    }
    if (
        (name === "insta_page_follower_change" ||
            name === "insta_page_profile_views" ||
            name === "engagement_over_time" ||
            name === "engagement_by_reach" ||
            name === "engagement_by_impressions" ||
            name === "engagement_by_video" ||
            name === "engagement_by_bookmark" ||
            name === "insta_story_replies" ||
            name === "insta_story_by_reach") &&
        !isAverage
    ) {
        let data = dt.data?.total || [];
        let lineChartData = data.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        return { [name]: { lineChartData: lineChartData } };
    }

    if ((name === "engagement_over_time" || name === "engagement_by_reach" || name === "engagement_by_impressions") && isAverage) {
        const { postData, countData } = dt;

        let lineChartData = [];

        countData.forEach((k, v) => {
            postData.forEach((s, t) => {
                const countDate = moment(k.key_as_string.split(" ")[0]);

                if (countDate.isSame(s.key_as_string.split(" ")[0])) {
                    const posts = s.doc_count;

                    const avg = isFinite(k.count / posts) ? k.count / posts : 0;

                    lineChartData.push({ x: +moment(k.key_as_string).format("x"), y: Number(avg.toFixed(1)) });
                }
            });
        });

        return { [name]: { lineChartData: lineChartData } };
    }
};

export {
    fetchVOCSubtpcsCnt,
    chartUrlMap,
    formatTimeSeriesPubData,
    formatTimeSeriesMentions,
    formatTimeSeriesMentionsSubtopics,
    getAccessToken,
    getUserId,
    getCompanyId,
    getLiteCompanyId,
    getUserType,
    getReqParams,
    getMomentsData,
    getMomentsOvertimeData,
    delete_cookie,
    get_cookie,
    getAppliedDates,
    getDateParamsTrends,
};

export const formatTokenLists = (tokenLists) => {
    let obj = {};

    let tempProfileName = null;

    tokenLists.length > 0 &&
        tokenLists.forEach(({ platform, page_name, page_username }) => {
            tempProfileName = page_name ? page_name : page_username;

            if (obj[platform]) {
                obj[platform].count = obj[platform].count + 1;
                obj[platform].profiles.push(tempProfileName);
            } else {
                obj[platform] = {
                    count: 1,
                    profiles: [tempProfileName],
                };
            }
        });
    return obj;
};
export const totalPlatformsConnected = (objects) => {
    let sum = 0;
    Object.values(objects)?.forEach((obj) => (sum += obj.count));
    return sum;
};
